import { Link } from "react-router-dom";

const PRINTIFY_URL = "https://bias-buster-store.printify.me/";

const columns = [
  {
    title: "Platform",
    links: [
      { to: "/feed", label: "Voting Feed" },
      { to: "/report-incident", label: "Report an Incident" },
      { to: "/about", label: "Our Mission" },
      { to: "/framework", label: "The Framework" },
      { to: "/guidelines", label: "Guidelines & SOPs" },
    ],
  },
  {
    title: "Coming Soon",
    links: [
      { to: "/bern", label: "BERN — Emergency Response" },
      { to: "/bbap-book", label: "The BBAP Book" },
    ],
  },
];

export function FooterLinks() {
  return (
    <>
      {columns.map((col) => (
        <div key={col.title}>
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 mb-4">{col.title}</h4>
          <ul className="space-y-2 text-sm text-zinc-400">
            {col.links.map((l) => (
              <li key={l.to}><Link to={l.to} className="hover:text-[#4FD1C5]">{l.label}</Link></li>
            ))}
          </ul>
        </div>
      ))}
      <div>
        <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 mb-4">Support the Movement</h4>
        <ul className="space-y-2 text-sm text-zinc-400">
          <li><Link to="/donate" className="hover:text-[#4FD1C5]">Donate</Link></li>
          <li><a href={PRINTIFY_URL} target="_blank" rel="noopener noreferrer" className="hover:text-[#4FD1C5]">Shop BBAP Merch</a></li>
          <li><Link to="/privacy" className="hover:text-[#4FD1C5]">Privacy Policy</Link></li>
          <li>
            <a
              href="mailto:charlesytstuff@gmail.com?subject=BiasBuster%20%E2%80%94%20Contact%20the%20Founder"
              data-testid="footer-contact-founder-link"
              className="hover:text-[#4FD1C5]"
            >
              Contact the Founder
            </a>
          </li>
        </ul>
      </div>
    </>
  );
}
